import React from 'react';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { i18n } = useTranslation();

  return (
    <header className="p-4 flex items-center justify-between border-b border-white/5">
      <div className="flex items-center gap-2">
        <span className="font-extrabold text-xl tracking-tight text-white">
          Candle<span className="text-purple-400">Duel</span>
        </span>
      </div>

      <div className="flex items-center gap-2">
        <select
          onChange={(e) => {
            const lang = e.target.value;
            i18n.changeLanguage(lang);
            // تنظیم جهت صفحه برای زبان‌های RTL (فارسی و عربی)
            document.documentElement.dir = ['fa', 'ar'].includes(lang) ? 'rtl' : 'ltr';
          }}
          value={i18n.language}
          className="bg-[#1E192C] border border-white/10 rounded-xl px-2.5 py-1 text-xs text-purple-300 font-medium focus:outline-none"
        >
          <option value="en">English</option>
          <option value="tr">Türkçe</option>
          <option value="hi">हिन्दी</option>
          <option value="ru">Русский</option>
          <option value="es">Español</option>
          <option value="zh">中文</option>
          <option value="ar">العربية</option>
          <option value="fa">فارسی</option>
        </select>

        <div className="bg-[#1E192C] px-3 py-1 rounded-xl border border-white/10 text-xs font-bold text-amber-400 flex items-center gap-1">
          <span className="w-2 h-2 rounded-full bg-amber-400"></span> Bronze
        </div>
      </div>
    </header>
  );
};

export default Header;